import TransferElements from 'transfer-elements';

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import IMask from 'imask';

import MicroModal from 'micromodal';

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

import likely from 'ilyabirman-likely';

document.addEventListener('DOMContentLoaded', () => {
	const htmlEl = document.documentElement;
	const bodyEl = document.body;
	const header = document.querySelector('.header');
	const burger = document?.querySelector('[data-burger]');
	const nav = document?.querySelector('[data-nav]');
	const navItems = document?.querySelectorAll('[data-nav-item]');
	const overlay = document?.querySelector('[data-nav-overlay]');
	const fixedEls = document?.querySelectorAll('[data-fixed');
	const styleHtmlEl = window.getComputedStyle(htmlEl);
	const currentLang = styleHtmlEl.getPropertyValue('--current-lang').trim();

	const ruImg = document?.querySelector('[data-icon-url-ru]').innerHTML;
	const enImg = document?.querySelector('[data-icon-url-en]').innerHTML;
	const kzImg = document?.querySelector('[data-icon-url-kk]').innerHTML;

	likely.initiate();

	(function goBackTop() {
		'use strict';

		// Получаем кнопку в переменную
		const btn = document?.querySelector('[data-go-back-top]');

		function handleClick() {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth',
			});
		}

		function addRemoveActiveClass() {
			// Сколько нужно проскролить, чтобы появилась кнопка
			const breakpoint = 1000;

			// Если прокрутили на значение breakpoint, задаём кнопке указанный класс
			if (window.scrollY >= breakpoint) {
				btn.classList.add('is-active');
			} else {
				btn.classList.remove('is-active');
			}
		}

		if (btn) {
			window.addEventListener('scroll', addRemoveActiveClass);

			btn.addEventListener('click', handleClick);
		}
	})();

	(function readProgressLine() {
		'use strict';

		// Добавляем в body блок для линии прогресса прокрутки
		let lineAppend = document.createElement('div');

		lineAppend.className = 'progress-line';

		lineAppend.innerHTML = '<div class="progress-line__item"></div>';

		document.body.append(lineAppend);

		// Получаем внутренний элемент оболочки линии прогресса прокрутки
		const line = document.querySelector('.progress-line__item');

		function progressAnimation() {
			let scrollTop = window.scrollY;

			let windowHeight = window.innerHeight;

			let siteHeight = document.documentElement.scrollHeight;

			let percentageProgress = Math.floor(
				(scrollTop / (siteHeight - windowHeight)) * 100,
			);

			line.style.width = `${percentageProgress}%`;
		}

		progressAnimation();

		window.addEventListener('scroll', () => {
			progressAnimation();
		});
	})();

	(function getScrollbarWidth() {
		'use strict';

		const scrollbarWidth = window.innerWidth - bodyEl.offsetWidth;

		htmlEl.style.setProperty('--scroll-width', `${scrollbarWidth}px`);

		return scrollbarWidth;
	})();

	function disableScroll() {
		'use strict';

		let pagePosition = window.scrollY;

		bodyEl.classList.add('stop-scroll');

		bodyEl.dataset.position = pagePosition;

		htmlEl.style.setProperty('--top-position', `-${pagePosition}px`);

		htmlEl.style.scrollBehavior = 'unset';
	}

	function enableScroll() {
		'use strict';
		let pagePosition = parseInt(bodyEl.dataset.position, 10);

		bodyEl.classList.remove('stop-scroll');

		window.scroll({
			top: pagePosition,

			left: 0,
		});

		bodyEl.removeAttribute('data-position');

		htmlEl.style.setProperty('--top-position', 'auto');

		htmlEl.style.scrollBehavior = '';
	}

	(function burgerInit() {
		'use strict';

		if (burger && nav) {
			burger.addEventListener('click', () => {
				burger.classList.toggle('burger--is-active');

				header.classList.toggle('header--is-active');

				nav.classList.toggle('nav--is-visible');

				fixedEls.forEach(function (el) {
					el.classList.toggle('not-leap');
				});

				if (burger.getAttribute('aria-expanded') === 'false') {
					burger.setAttribute('aria-expanded', 'true');

					burger.setAttribute('aria-pressed', 'true');

					if (currentLang == 'en') {
						burger.setAttribute('aria-label', 'Close the menu');
					} else if (currentLang == 'kk') {
						burger.setAttribute('aria-label', 'Мәзірді жабу');
					} else {
						burger.setAttribute('aria-label', 'Закрыть меню');
					}

					disableScroll();
				} else {
					burger.setAttribute('aria-expanded', 'false');

					burger.setAttribute('aria-pressed', 'false');

					if (currentLang == 'en') {
						burger.setAttribute('aria-label', 'Open the menu');
					} else if (currentLang == 'kk') {
						burger.setAttribute('aria-label', 'Мәзірді ашыңыз');
					} else {
						burger.setAttribute('aria-label', 'Открыть меню');
					}

					enableScroll();
				}
			});
		}

		if (navItems) {
			navItems.forEach(el => {
				el.addEventListener('click', () => {
					enableScroll();

					if (burger) {
						burger.setAttribute('aria-expanded', 'false');

						burger.setAttribute('aria-pressed', 'false');

						burger.setAttribute('aria-label', 'Открыть меню');

						burger.classList.remove('burger--is-active');
					}

					if (nav) {
						nav.classList.remove('nav--is-active');
					}

					if (header) {
						header.classList.remove('header--is-active');
					}
				});
			});
		}

		if (overlay) {
			overlay.addEventListener('click', () => {
				if (burger) {
					burger.setAttribute('aria-expanded', 'false');

					burger.setAttribute('aria-pressed', 'false');

					burger.setAttribute('aria-label', 'Открыть меню');

					burger.classList.remove('burger--is-active');
				}

				if (nav) {
					nav.classList.remove('nav--is-active');
				}

				if (header) {
					header.classList.remove('header--is-active');
				}

				enableScroll();
			});
		}
	})();

	(function headerSearchInit() {
		'use strict';

		const searchBtn = document?.querySelector('[data-search-btn]');
		const searchWrapper = document?.querySelector(
			'.header__block [data-search-wrapper]',
		);
		const searchForm = searchWrapper?.querySelector('form'); // или сам search-wrapper, если нужно

		if (searchBtn && searchWrapper) {
			// Функция для скрытия поиска
			function hideSearch() {
				searchBtn.classList.remove('search-btn--is-active');
				searchWrapper.classList.remove('search-wrapper--is-visible');
				searchBtn.setAttribute('aria-expanded', 'false');
				searchBtn.setAttribute('aria-pressed', 'false');

				if (currentLang == 'en') {
					searchBtn.setAttribute('aria-label', 'Show the search field');
				} else if (currentLang == 'kk') {
					searchBtn.setAttribute('aria-label', 'Іздеу өрісін көрсету');
				} else {
					searchBtn.setAttribute('aria-label', 'Показать поисковое поле');
				}
			}

			// Функция для показа поиска
			function showSearch() {
				searchBtn.classList.add('search-btn--is-active');
				searchWrapper.classList.add('search-wrapper--is-visible');
				searchBtn.setAttribute('aria-expanded', 'true');
				searchBtn.setAttribute('aria-pressed', 'true');

				if (currentLang == 'en') {
					searchBtn.setAttribute('aria-label', 'Hidden the search field');
				} else if (currentLang == 'kk') {
					searchBtn.setAttribute('aria-label', 'Іздеу өрісін жасыру');
				} else {
					searchBtn.setAttribute('aria-label', 'Скрыть поисковое поле');
				}
			}

			// Обработчик клика по кнопке
			searchBtn.addEventListener('click', e => {
				e.stopPropagation(); // Останавливаем всплытие, чтобы не сработал клик по document

				if (searchBtn.getAttribute('aria-expanded') === 'false') {
					showSearch();
					// Фокусируемся на поле ввода после открытия
					const input = searchWrapper.querySelector('input[type="search"]');
					if (input) setTimeout(() => input.focus(), 100);
				} else {
					hideSearch();
				}
			});

			// Закрытие при клике вне области поиска и кнопки
			document.addEventListener('click', e => {
				const isClickInsideSearch = searchWrapper.contains(e.target);
				const isClickOnButton = searchBtn.contains(e.target);

				// Если кликнули не по кнопке и не внутри поиска, и поиск открыт
				if (!isClickOnButton && !isClickInsideSearch) {
					if (searchBtn.getAttribute('aria-expanded') === 'true') {
						hideSearch();
					}
				}
			});

			// Закрытие по клавише Escape
			document.addEventListener('keydown', e => {
				if (
					e.key === 'Escape' &&
					searchBtn.getAttribute('aria-expanded') === 'true'
				) {
					hideSearch();
					searchBtn.focus(); // Возвращаем фокус на кнопку
				}
			});

			// Опционально: закрытие при скролле (если нужно)
			// document.addEventListener('scroll', () => {
			//     if (searchBtn.getAttribute('aria-expanded') === 'true') {
			//         hideSearch();
			//     }
			// });
		}
	})();

	function getFullYear(selector) {
		'use strict';

		const currentYear = new Date().getFullYear();

		const yearEl = document?.querySelector(selector);

		const metaYear = document?.querySelector('[itemprop="copyrightYear"]');

		if (yearEl) {
			yearEl.innerHTML = currentYear;
		}

		if (metaYear) {
			metaYear.setAttribute('content', currentYear);
		}
	}
	getFullYear('.footer__year');

	function slideDown(target, duration) {
		target.style.removeProperty('display');

		let display = window.getComputedStyle(target).display;

		if (display === 'none') display = 'grid';

		target.style.display = display;

		let height = target.offsetHeight;

		target.style.overflow = 'hidden';

		target.style.height = 0;

		target.style.paddingTop = 0;

		target.style.paddingBottom = 0;

		target.style.marginTop = 0;

		target.style.marginBottom = 0;

		target.offsetHeight;

		target.style.boxSizing = 'border-box';

		target.style.transitionProperty = 'height, margin, padding';

		target.style.transitionDuration = duration + 'ms';

		target.style.height = height + 'px';

		target.style.border = 'none';

		target.style.removeProperty('padding-top');

		target.style.removeProperty('padding-bottom');

		target.style.removeProperty('margin-top');

		target.style.removeProperty('margin-bottom');

		target.style.removeProperty('border');

		window.setTimeout(() => {
			target.style.removeProperty('height');

			target.style.removeProperty('overflow');

			target.style.removeProperty('transition-duration');

			target.style.removeProperty('transition-property');

			target.style.removeProperty('border');
		}, duration);
	}

	function slideUp(target, duration) {
		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = duration + 'ms';
		target.style.boxSizing = 'border-box';
		target.style.height = target.offsetHeight + 'px';
		target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = 0;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		target.style.border = 'none';

		window.setTimeout(() => {
			target.style.display = 'none';
			target.style.removeProperty('height');
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
			target.style.removeProperty('border');
		}, duration);
	}

	function slideToggle(target, duration) {
		if (window.getComputedStyle(target).display === 'none') {
			return slideDown(target, duration);
		} else {
			return slideUp(target, duration);
		}
	}

	function getElementHeight(selector, varHeightName) {
		function heightDetermination() {
			const element = document?.querySelector(`${selector}`);

			if (element) {
				const elementHeight = element.offsetHeight;

				htmlEl.style.setProperty(`--${varHeightName}`, `${elementHeight}px`);
			}
		}

		heightDetermination();

		window.addEventListener('resize', heightDetermination);
	}
	getElementHeight('[data-select-expanded-title]', 'select-title-height');
	getElementHeight('.header', 'header-height');

	const submenuOpenClose = () => {
		const submenu = document?.querySelector('.sub-menu-wrap');
		const buttons = document?.querySelectorAll('[data-menu-btn-submenu]');

		if (!submenu || !buttons) return;

		buttons.forEach(el => {
			el.addEventListener('click', e => {
				el.classList.toggle('is-active');

				const parent = e.target.closest('[data-menu-item]');
				const currentSubmenu = parent?.querySelector('.sub-menu-wrap');

				slideToggle(currentSubmenu, 300);
			});
		});
	};
	submenuOpenClose();

	(function addHeaderScrollClass() {
		'use strict';

		// Проверяем, существует ли элемент
		if (!header) return;

		// Функция для обработки события скролла
		function handleScroll() {
			// Проверяем, произошел ли скролл
			if (window.scrollY > 0) {
				// Добавляем класс при начале скролла
				header.classList.add('header--scroll');
			} else {
				// Удаляем класс при возврате в начало
				header.classList.remove('header--scroll');
			}
		}

		// Добавляем обработчик события
		window.addEventListener('scroll', () => {
			// Используем requestAnimationFrame для оптимизации
			requestAnimationFrame(handleScroll);
		});
	})();

	(function transferInit() {
		const ourMeritsImg = document.querySelector('.our-merits-image');

		if (ourMeritsImg) {
			new TransferElements({
				sourceElement: ourMeritsImg,
				breakpoints: {
					832: {
						targetElement: document.getElementById('our-merits'),
						targetPosition: 0,
					},
				},
			});
		}

		const pageNav = document?.querySelector('[data-page-nav]');

		if (pageNav) {
			new TransferElements({
				sourceElement: pageNav,
				breakpoints: {
					992: {
						targetElement: document?.querySelector('[data-article-header-top]'),
						targetPosition: 2,
					},
				},
			});
		}
	})();

	function resizableSwiper(breakpoint, swiperClass, swiperSettings, callback) {
		let swiper;

		breakpoint = window.matchMedia(breakpoint);

		const enableSwiper = function (className, settings) {
			swiper = new Swiper(className, settings);

			if (callback) {
				callback(swiper);
			}
		};

		const checker = function () {
			if (breakpoint.matches) {
				return enableSwiper(swiperClass, swiperSettings);
			} else {
				if (swiper !== undefined) swiper.destroy(true, true);
				return;
			}
		};

		breakpoint.addEventListener('change', checker);
		checker();
	}

	const sliderOne = document?.querySelector('.our-partners__slider');

	if (sliderOne) {
		resizableSwiper('(min-width: 576.96px)', '.our-partners__slider', {
			modules: [Navigation],

			loop: true,

			spaceBetween: 40,

			slidesPerView: 7,

			freeMode: {
				enabled: true, // включаем свободный режим
				momentum: false, // отключаем инерцию
			},

			navigation: {
				prevEl: '.our-partners .swiper-button-prev',
				nextEl: '.our-partners .swiper-button-next',
			},
		});
	}

	const sliderReviews = document?.querySelector('.reviews__slider');

	if (sliderReviews) {
		resizableSwiper('(max-width: 576px)', '.reviews__slider', {
			modules: [Navigation],

			loop: true,

			navigation: {
				prevEl: '.reviews .swiper-button-prev',
				nextEl: '.reviews .swiper-button-next',
			},
		});
	}

	(function initSwipers() {
		'use strict';

		const swiperElOne = document?.querySelector('.news__slider');

		if (swiperElOne) {
			const swiper = new Swiper(swiperElOne, {
				modules: [Navigation],

				navigation: {
					nextEl: '.news .swiper-button-next',
					prevEl: '.news .swiper-button-prev',
				},

				breakpoints: {
					320: {
						slidesPerView: 1.15,
						spaceBetween: 20,
					},
					375: {
						slidesPerView: 1.2,
						spaceBetween: 20,
					},
					1100: {
						slidesPerView: 2,
						spaceBetween: 24,
					},
				},
			});
		}

		const swiperCases = document?.querySelector('.cases__slider');

		if (swiperCases) {
			const swiper = new Swiper(swiperCases, {
				modules: [Navigation],

				navigation: {
					nextEl: '.cases .swiper-button-next',
					prevEl: '.cases .swiper-button-prev',
				},

				breakpoints: {
					320: {
						slidesPerView: 1.15,
						spaceBetween: 20,
					},
					375: {
						slidesPerView: 1.2,
						spaceBetween: 20,
					},
					600: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					992: {
						slidesPerView: 3,
						spaceBetween: 20,
					},
				},
			});
		}
	})();

	(function imaskInit() {
		'use strict';

		const computedStyle = getComputedStyle(htmlEl);
		const currentLang = computedStyle.getPropertyValue('--current-lang').trim();

		const elements = document.querySelectorAll('input[type="tel"');

		if (!elements.length) return;

		const maskOptions = {
			mask: '+{7} (000) 000-00-00',
		};

		elements.forEach(el => {
			const mask = IMask(el, maskOptions);
		});
	})();

	(function initMicromodal() {
		'use strict';

		const modals = document?.querySelectorAll('.modal');

		if (modals.length > 0) {
			function onShow(modal) {
				console.info(`${modal.id} is shown`);

				disableScroll();
			}

			function onClose(modal) {
				console.info(`${modal.id} is hidden`);

				enableScroll();

				const iFrames = document?.querySelectorAll('.modal iframe');

				if (iFrames.length > 0) {
					iFrames.forEach(item => {
						item.src = item.src;
					});
				}

				const videos = document?.querySelectorAll('video');

				if (videos.length > 0) {
					videos.forEach(item => {
						item.pause();
					});
				}
			}

			MicroModal.init({
				onShow: onShow,
				onClose: onClose,
				disableScroll: true,
				awaitOpenAnimation: true,
				awaitCloseAnimation: true,
			});
		}
	})();

	(function spoilers() {
		'use strict';

		// Собираем все элементы с атрибутом data-spoilers-list
		const spoilersArray = document?.querySelectorAll('[data-spoilers-list]');

		const durationSpeed = '500';

		// Проверяем есть ли они
		if (spoilersArray.length > 0) {
			// Получение обычных спойлеров
			const spoilersRegular = Array.from(spoilersArray).filter(
				function (item, index, self) {
					return !item.dataset.spoilersList.split(',')[0];
				},
			);

			// Инициализация обычных спойлеров
			if (spoilersRegular.length > 0) {
				initSpoilers(spoilersRegular);
			}

			// Получение спойлеров с медиазапросами
			const spoilersMedia = Array.from(spoilersArray).filter(
				function (item, index, self) {
					return item.dataset.spoilersList.split(',')[0];
				},
			);

			// Инициализация спойлеров с медиазапросами
			if (spoilersMedia.length > 0) {
				const breakpointsArray = [];

				spoilersMedia.forEach(item => {
					const params = item.dataset.spoilersList;

					const breakpoint = [];

					const paramsArray = params.split(',');

					breakpoint.value = paramsArray[0];

					breakpoint.type = paramsArray[1] ? paramsArray[1].trim() : 'max';

					breakpoint.item = item;

					breakpointsArray.push(breakpoint);
				});

				// Получаем уникальные брейкпоинты
				let mediaQueries = breakpointsArray.map(function (item) {
					return (
						'(' +
						item.type +
						'-width: ' +
						item.value +
						'px),' +
						item.value +
						',' +
						item.type
					);
				});

				mediaQueries = mediaQueries.filter(function (item, index, self) {
					return self.indexOf(item) === index;
				});

				// Работаем с каждым брейкпоинтом
				mediaQueries.forEach(breakpoint => {
					const paramsArray = breakpoint.split(',');

					const mediaBreakpoint = paramsArray[1];

					const mediaType = paramsArray[2];

					const matchMedia = window.matchMedia(paramsArray[0]);

					// Объекты с нужными условиями
					const spoilersArray = breakpointsArray.filter(function (item) {
						if (item.value === mediaBreakpoint && item.type === mediaType) {
							return true;
						}
					});

					// Событие
					matchMedia.addEventListener('change', function () {
						initSpoilers(spoilersArray, matchMedia);
					});

					initSpoilers(spoilersArray, matchMedia);
				});
			}
		}

		// Инициализация
		function initSpoilers(spoilersArray, matchMedia = false) {
			spoilersArray.forEach(spoilersBlock => {
				spoilersBlock = matchMedia ? spoilersBlock.item : spoilersBlock;

				if (matchMedia.matches || !matchMedia) {
					spoilersBlock.classList.add('init');

					initSpoilerBody(spoilersBlock);

					spoilersBlock.addEventListener('click', setSpoilerAction);
				} else {
					spoilersBlock.classList.remove('init');

					initSpoilerBody(spoilersBlock, false);

					spoilersBlock.removeEventListener('click', setSpoilerAction);
				}
			});
		}

		// Работа с контентом
		function initSpoilerBody(spoilersBlock, hideSpoilerBody = true) {
			const spoilerTitles = spoilersBlock.querySelectorAll(
				'[data-spoiler-title]',
			);

			if (spoilerTitles.length > 0) {
				spoilerTitles.forEach(spoilerTitle => {
					if (hideSpoilerBody) {
						spoilerTitle.removeAttribute('tabindex');

						if (!spoilerTitle.classList.contains('active')) {
							const spoilerTitleParent =
								spoilerTitle?.closest('[data-spoiler]');

							if (spoilerTitleParent) {
								const targetContent = spoilerTitleParent.querySelector(
									'[data-spoiler-content]',
								);

								targetContent.hidden = true;
							}
						}
					} else {
						spoilerTitle.setAttribute('tabindex', '-1');

						const spoilerTitleParent = spoilerTitle?.closest('[data-spoiler]');

						if (spoilerTitleParent) {
							const targetContent = spoilerTitleParent.querySelector(
								'[data-spoiler-content]',
							);

							targetContent.hidden = false;
						}
					}
				});
			}
		}

		function setSpoilerAction(e) {
			const el = e.target;

			if (
				el.hasAttribute('data-spoiler-title') ||
				el.closest('[data-spoiler-title]')
			) {
				const spoilerTitle = el.hasAttribute('data-spoiler-title')
					? el
					: el.closest('[data-spoiler-title]');

				const spoilersBlock = spoilerTitle.closest('[data-spoilers-list]');

				const oneSpoiler = spoilersBlock.hasAttribute('data-one-spoiler')
					? true
					: false;

				if (!spoilersBlock.querySelectorAll('.slide').length) {
					if (oneSpoiler && !spoilerTitle.classList.contains('active')) {
						hideSpoilersBody(spoilersBlock);
					}

					spoilerTitle.classList.toggle('active');

					const spoilerTitleParent = spoilerTitle.closest('[data-spoiler]');

					const targetContent = spoilerTitleParent.querySelector(
						'[data-spoiler-content]',
					);

					slideToggle(targetContent, durationSpeed);
				}
				e.preventDefault();
			}
		}

		function hideSpoilersBody(spoilersBlock) {
			const spoilerActiveTitle = spoilersBlock.querySelector(
				'[data-spoiler-title].active',
			);

			const activeTitleParent = spoilerActiveTitle.closest('[data-spoiler]');

			const targetContent = activeTitleParent.querySelector(
				'[data-spoiler-content]',
			);

			if (spoilerActiveTitle) {
				spoilerActiveTitle.classList.remove('active');

				slideUp(targetContent, durationSpeed);
			}
		}
	})();

	function displayCurrentYear(selector) {
		'use strict';

		const currentYear = new Date().getFullYear();

		const yearEl = document?.querySelector(selector);

		const metaYear = document?.querySelector('[itemprop="copyrightYear"]');

		if (yearEl) {
			yearEl.innerHTML = currentYear;
		}

		if (metaYear) {
			metaYear.setAttribute('content', currentYear);
		}
	}
	displayCurrentYear('.footer__year');

	const lightbox = new PhotoSwipeLightbox({
		gallery: '[class*="pswp-gallery"]',
		children: '[data-pswp-child]',
		pswpModule: PhotoSwipe,
	});
	lightbox.init();

	(function createPageNavItems() {
		'use strict';

		const titles = document?.querySelectorAll('[data-article-main] h2');

		const pageNavMenu = document?.querySelector('[data-page-nav-menu]');

		if (!titles || !pageNavMenu) {
			return function () {
				console.log('Нет заголовков или списка меню');
			};
		}

		titles.forEach(function (el, index) {
			const titleText = el.textContent;

			if (!el.id) {
				el.id = `h2-${index}`;
			}

			const titleId = el.getAttribute('id');

			pageNavMenu.insertAdjacentHTML(
				'beforeend',
				`<li class="page-nav__item"><a class="page-nav__link state-accent" href="#${titleId}" data-page-nav-link="${titleId}">${titleText}</a></li>`,
			);
		});
	})();

	(function selectExpanded() {
		'use strict';

		const selects = document.querySelectorAll('[data-select-expanded]');

		if (!selects) return;

		// Функция для обработки клика
		function handleClick(e) {
			const target = e.target;
			const parent = target.closest('[data-select-expanded]');
			const title = parent.querySelector('[data-select-expanded-title]');
			const content = parent.querySelector('[data-select-expanded-content]');

			if (target.closest('[data-select-expanded-title]')) {
				handleTitleClick(title, content);
			} else if (target.closest('[data-option-inner-button]')) {
				handleOptionClick(target, parent, title, content);
			}
		}

		// Обработка клика по заголовку
		function handleTitleClick(title, content) {
			const isActive = title.classList.contains('is-active');

			title.classList.toggle('is-active', !isActive);
			content.classList.toggle('is-active', !isActive);

			const titleHeight = title.offsetHeight;

			document.documentElement.style.setProperty(
				'--select-expanded-title-height',
				`${titleHeight}px`,
			);

			slideToggle(content, 300);
			title.setAttribute('aria-expanded', !isActive);
		}

		// Обработка клика по опции
		function handleOptionClick(target, parent, title, content) {
			const innerBtns = parent.querySelectorAll('[data-option-inner-button]');

			innerBtns.forEach(btn => btn.classList.remove('is-active'));

			target.classList.add('is-active');

			title.innerHTML = target.innerHTML;
			slideToggle(content, 300);

			title.classList.remove('is-active');
			title.setAttribute('aria-expanded', false);
			content.classList.remove('is-active');

			if (target.hasAttribute('style')) {
				const inlineStyles = target.style.cssText;

				title.style.cssText = inlineStyles;
			}

			const inputsWrap = target.closest('.input-tel-wrap');

			const inputCountryName = inputsWrap?.querySelector(
				'.country-name-hidden',
			);

			if (target.hasAttribute('title') ?? inputCountryName) {
				const targetLang = target.getAttribute('title');

				if (
					targetLang == 'Казахский' ||
					targetLang == 'Kazakh' ||
					targetLang == 'Қазақ тілі'
				) {
					inputCountryName.value = 'Казахский';
				} else if (
					targetLang == 'Английский' ||
					targetLang == 'English' ||
					targetLang == 'Ағылшын тілі'
				) {
					inputCountryName.value = 'Английский';
				} else {
					inputCountryName.value = 'Русский';
				}
			}
		}

		// Обработка клика вне селекта
		function handleDocumentClick(e) {
			if (!e.target.closest('[data-select-expanded]')) {
				const titles = document.querySelectorAll(
					'[data-select-expanded-title]',
				);

				const contents = document.querySelectorAll(
					'[data-select-expanded-content]',
				);

				titles.forEach(title => {
					title.classList.remove('is-active');
					title.setAttribute('aria-expanded', false);
				});

				contents.forEach(content => slideUp(content, 300));
			}
		}

		// Добавляем обработчики событий
		selects.forEach(select => {
			select.addEventListener('click', handleClick);
		});

		document.addEventListener('click', handleDocumentClick);
	})();

	(function setLabelsName() {
		const labelsName = document?.querySelectorAll('.form__label--name');
		const labelsPhone = document?.querySelectorAll('.form__label--phone');

		if (currentLang === 'en') {
			labelsName.forEach(el => (el.innerHTML = 'Name'));
			labelsPhone.forEach(el => (el.innerHTML = 'Phone'));
		} else if (currentLang === 'kk') {
			// Здесь будет код для казахского языка
			labelsName.forEach(el => (el.innerHTML = 'Аты'));
		}
	})();

	(function setSelectIcons() {
		'use strict';

		if (!ruImg || !enImg || !kzImg) return;

		const selectOptionsRu = document.querySelectorAll(
			'.form [data-option-country-code-ru]',
		);
		const selectOptionsEn = document.querySelectorAll(
			'.form [data-option-country-code-en]',
		);
		const selectOptionsKk = document.querySelectorAll(
			'.form [data-option-country-code-kk]',
		);

		if (!selectOptionsRu || !selectOptionsEn || !selectOptionsKk) return;

		function setUrls(elements, icon) {
			elements.forEach(el => {
				el.style.backgroundImage = `url(${icon})`;
			});
		}

		setUrls(selectOptionsRu, ruImg);
		setUrls(selectOptionsEn, enImg);
		setUrls(selectOptionsKk, kzImg);

		console.log('Icons urls replace');
	})();

	(function setSelectActiveLang() {
		'use strict';

		if (!enImg || !kzImg) return;

		const selectTitles = document.querySelectorAll(
			'.form [data-select-expanded-title]',
		);

		const selectOptions = document.querySelectorAll(
			'.form [data-option-inner-button]',
		);

		if (!selectTitles || !selectOptions) return;

		switch (currentLang) {
			case 'en':
				selectTitles.forEach(el => {
					el.style.backgroundImage = `url(${enImg})`;
				});

				selectOptions.forEach(el => {
					el.classList.remove('is-active');

					if (el.hasAttribute('data-option-country-code-en')) {
						el.classList.add('is-active');
					}
				});
				break;

			case 'kk':
				selectTitles.forEach(el => {
					el.style.backgroundImage = `url(${kzImg})`;
				});

				selectOptions.forEach(el => {
					el.classList.remove('is-active');
					if (el.hasAttribute('data-option-country-code-kk')) {
						el.classList.add('is-active');
					}
				});
				break;

			default:
				console.info('Выбран русский язык:', currentLang);
		}
	})();

	(function setSelectAttributes() {
		'use strict';

		const selectLang = document.querySelector('[data-select-lang]');

		if (selectLang && currentLang !== 'ru') {
			const titleValue = selectLang.querySelector(
				'[data-select-expanded-title] .select-expanded__value',
			);

			if (!titleValue) {
				console.error('Элемент titleValue не найден');
				return;
			}

			titleValue.innerHTML = currentLang;

			const innerEls = selectLang.querySelectorAll(
				'[data-option-inner-button]',
			);

			innerEls.forEach(function (el) {
				el.classList.remove('is-active');

				const elValue = el.querySelector('.select-expanded__value');

				if (elValue) {
					if (elValue.textContent === currentLang) {
						el.classList.add('is-active');
					}
				}
			});
		}

		const formSelects = document?.querySelectorAll(
			'.form [data-select-expanded]',
		);

		if (!formSelects) {
			console.error('Элементы formSelects не найдены');

			return;
		}

		if (formSelects && currentLang !== 'ru') {
			formSelects.forEach(el => {});
		}
	})();

	(function setInputLangValue() {
		const inputsCountryName = document?.querySelectorAll(
			'.country-name-hidden',
		);

		if (inputsCountryName && currentLang == 'en') {
			inputsCountryName.forEach(el => {
				el.value = 'Английский';
			});
		} else if (inputsCountryName && currentLang == 'kk') {
			inputsCountryName.forEach(el => {
				el.value = 'Казахский';
			});
		}
	})();

	(function localizeAttributes() {
		const translations = {
			en: {
				'Выберите язык': 'Select language',
				Русский: 'Russian',
				Английский: 'English',
				Казахский: 'Kazakh',
			},
			kk: {
				'Выберите язык': 'Тілді таңдаңыз',
				Русский: 'Орыс тілі',
				Английский: 'Ағылшын тілі',
				Казахский: 'Қазақ тілі',
			},
		};

		// Функция для обновления атрибутов
		function updateLanguageAttributes(lang) {
			const translation = translations[lang];

			if (translation) {
				// Обновляем все тексты
				Object.keys(translation).forEach(originalText => {
					const translatedText = translation[originalText];

					// Находим и обновляем элементы с aria-label
					document
						.querySelectorAll(`[aria-label="${originalText}"]`)
						.forEach(element => {
							element.setAttribute('aria-label', translatedText);
						});

					// Находим и обновляем элементы с title
					document
						.querySelectorAll(`[title="${originalText}"]`)
						.forEach(element => {
							element.setAttribute('title', translatedText);
						});

					// Также можно обновлять текст внутри элементов, если нужно
					document
						.querySelectorAll(`[data-i18n="${originalText}"]`)
						.forEach(element => {
							element.textContent = translatedText;
						});
				});
			}
		}
		updateLanguageAttributes(currentLang);
	})();

	const setFormTextData = () => {
		const inputs = document?.querySelectorAll('.form .form__btn');
		const formNotes = document?.querySelectorAll('.form .form__note p');

		if (!inputs && !formNotes) return;

		if (inputs) {
			inputs.forEach(function (el) {
				if (currentLang == 'en') {
					el.value = 'Send';
				} else if (currentLang == 'kk') {
					el.value = 'Жіберу';
				} else {
					el.value = 'Отправить';
				}
			});
		}

		if (formNotes) {
			formNotes.forEach(function (el) {
				if (currentLang == 'en') {
					el.innerHTML =
						'By pressing the "Send" button, you give your consent to the processing of personal information.';
				} else if (currentLang == 'kk') {
					el.innerHTML =
						'"Жіберу" батырмасын басу арқылы сіз жеке деректерді өңдеуге келісім бересіз.';
				} else {
					el.innerHTML =
						'Нажимая на кнопку "Отправить", вы даете согласие на обработку персональных данных.';
				}
			});
		}
	};
	setFormTextData();
});
